import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import {
    BlobTypeStoreReadSettingsAdapter,
    blobTypeStoreReadSettingsAdapts
} from './blob-type-store-read-settings.adapter';
import { AzureFileStorageStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/azure-file-storage-store-read-settings';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { FilePathMode } from 'app/registries/consts/metadata-consts';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureFileStorageStoreReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        deleteFilesAfterCompletion: '*',
        prefix: '*'
    }
})
export class AzureFileStorageStoreReadSettingsAdapter extends BlobTypeStoreReadSettingsAdapter<
    AzureFileStorageStoreReadSettings,
    Model.StoreReadSettings
> {
    protected override async _toModel(
        resource: Model.StoreReadSettings,
        copySource: CopySource
    ): Promise<AzureFileStorageStoreReadSettings> {
        const azureFileStorageModel = await super._toModel(resource, copySource);
        if (resource.prefix != null) {
            ValueAdapter.toModel(azureFileStorageModel, AzureFileStorageStoreReadSettings.PREFIX, resource.prefix);
            azureFileStorageModel.filePathMode = FilePathMode.PREFIX;
        }
        ValueAdapter.toModel(
            azureFileStorageModel,
            AzureFileStorageStoreReadSettings.DELETE_FILE_AFTER_COMPLETION,
            resource.deleteFilesAfterCompletion
        );
        return azureFileStorageModel;
    }

    protected override async _toResource(
        settings: AzureFileStorageStoreReadSettings
    ): Promise<Model.StoreReadSettings> {
        const azureFileStorageResource = await super._toResource(settings);
        if (azureFileStorageResource != null && settings.filePathMode === FilePathMode.PREFIX) {
            azureFileStorageResource.prefix = ValueAdapter.toResource(
                settings,
                AzureFileStorageStoreReadSettings.PREFIX
            );
        }
        azureFileStorageResource.deleteFilesAfterCompletion = ValueAdapter.toResource(
            settings,
            AzureFileStorageStoreReadSettings.DELETE_FILE_AFTER_COMPLETION
        );
        return azureFileStorageResource;
    }
}
